import { render, staticRenderFns } from "./TabelaDescontos.vue?vue&type=template&id=60d24baa&"
import script from "./TabelaDescontos.vue?vue&type=script&lang=js&"
export * from "./TabelaDescontos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports